import React from "react";
import "../../styles/categories.css";

const Categories = () => {
const admissionsData = [
    {
      id: 1,
      title: "Fee Structure",
      desc: "Affordable with installment options.",
      // Image: Calculator, coins, or budgeting to represent affordability
      img: "https://images.unsplash.com/photo-1554224154-26032ffc0d07?auto=format&fit=crop&w=600&q=80"
    },
    {
      id: 2,
      title: "Eligibility",
      desc: "As per ICAI, ICMAI, and ICSI guidelines.",
      // Image: A checklist or checking requirements on a laptop
      img: "https://images.unsplash.com/photo-1555421689-491a97ff2040?auto=format&fit=crop&w=600&q=80"
    },
    {
      id: 3,
      title: "Intake",
      desc: "Open year-round (recorded classes available anytime).",
      // Image: A calendar, schedule, or clock representing timing
      img: "https://images.unsplash.com/photo-1506784983877-45594efa4cbe?auto=format&fit=crop&w=600&q=80"
    }
  ];

  return (
    <section className="categories-section container">
      {/* Section Title */}
      <h2 className="section-title text-center">
        Admissions
      </h2>

      <div className="categories-wrapper">
        {admissionsData.map((item) => (
          <div key={item.id} className="category-item">
            {/* Image Container */}
            <div className="img-box">
              <img src={item.img} alt={item.title} className="category-img" />
            </div>
            
            {/* Text Content */}
            <h5 className="category-title">{item.title}</h5>
            <p className="category-desc">{item.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Categories;